<section id="main" class="bg-light">
     <div id="paymentContainer" class="container">
          <h1 [innerHTML]="'BillingReportsTitle' | translator:'base'">Billing Reports and Monthly Invoices</h1>
          <div class="row">
               <div id="billigReportContainer" class="col-lg-8">
                    <p [innerHTML]="'Invoice1' | translator:'invoice'">
                         Below is a detailed description of the billing reports and the single paper invoice that can be accessed from PSP. Clicking on the item name hyperlink will take you to the order page to request the desired report or invoice.
                    </p>
                    <ul>
                         <li class="mb-3">
                              <a routerLink="/billing-summary" 
                              [title]="'BillingSummaryLink' | translator:'invoice'" 
                              [innerHTML]="'BillingSummaryLink' | translator:'invoice'"
                              class="bold"
                         >
                              Billing Summary	
                              </a>:
                              <span [innerHTML]="'BillingSummaryTxt' | translator:'invoice'">
                                   This report provides a detailed listing of all associated charges that have been incurred during the selected billing cycle.<br><i>Note: If the billing cycle requested has not yet closed, the report is not final and may be missing charges. The report will reflect the following message: "Summary not final - Please check back later"</i>.
                              </span>
                         </li>
                         <li class="mb-3">
                              <a routerLink="/generic-statement" 
                                   [innerHTML]="'GenericStatementTitle' | translator:'invoice'"
                                   [title]="'GenericStatementTitle' | translator:'invoice'" 
                                   class="bold"
                              >
                                   Generic Statement
                              </a>: 
                              <span [innerHTML]="'GenericStatementTxt' | translator:'invoice'">
                                   This report provides a detailed statement of an account with a non-zero balance and no current activity or invoice.
                              </span>
                         </li>
                         <li>
                              <a routerLink="/single-paper-invoice" 
                                   [title]="'MonthlyInvoicesTitle' | translator:'invoice'" 
                                   [innerHTML]="'MonthlyInvoicesTitle' | translator:'invoice'" 
                                   class="bold"
                              >
                                   Monthly Invoices
                              </a>:
                              <span [innerHTML]="'MonthlyInvoicesTxt' | translator:'invoice'">
                                   This option enables users to view and download their account's invoice for the billing cycle selected. <br><i>Note: If the billing cycle selected has not yet closed, the invoiced amounts are not final. The invoice will display the following message: "Invoice not final - Please check back later"</i>.
                              </span>
                         </li>
                    </ul>
                    <p>
                         <span [innerHTML]="'PaymentDirections3e' | translator:'invoice'">
                              If you are unable to access your company's billing reports or paper invoice, please call customer support at 
                         </span>
                         <a href="tel:877-642-9499"
                            title="1-877-642-9499"
                            name="1-877-642-9499"
                            class="text-underline">1-877-642-9499
                         </a>.
                    </p>
               </div>
               <div class="col-lg-4 order-lg-2 sidebar">
                    <app-dashboardsupport></app-dashboardsupport>
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <h2 class="card-title h5 mt-0" [innerHTML]="'Resources' | translator:'base'">Resources</h2>
                              <ul>
                                   <li *ngIf="companyType === 'MC'">
                                        <button (click)="openDocument('PSPMotorCarrierEnrollment')" target="_blank"
                                             class="btn btn-link"
                                             [title]="'MAHEnrollAgreement' | translator:'base'" 
                                             [innerHTML]="'MAHEnrollAgreement' | translator:'base'" 
                                             name="MAHagreement"
                                             id="MAHagreement"
                                        >
                                             PSP Monthly Account Holder Enrollment Agreement
                                        </button>
                                   </li>
                                   <li *ngIf="companyType === 'ISP'">
                                        <button (click)="openDocument('ISPAccountHolderAgreement')" target="_blank"
                                             class="btn btn-link"
                                             [innerHTML]="'ISPEnrollAgreement' | translator:'base'"
                                             [title]="'ISPEnrollAgreement' | translator:'base'" 
                                             name="ISPagreement"
                                             id="ISPagreement"
                                        >
                                             PSP Industry Service Provider Enrollment Agreement
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                             [innerHTML]="'DisclosureAndAuth' | translator:'base'"
                                             (click)="openDocument('PSPDisclosureandAuthorizationForm')" 
                                             target="_blank"
                                             [title]="'DisclosureAndAuth' | translator:'base'"
                                             name="dna" id="dna"
                                        >
                                             Disclosure and Authorization Form
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link" 
                                             (click)="openDocument('BillingGuide')"
                                             target="_blank" 
                                             [title]="'billingManual' | translator:'payment'"
                                             [innerHTML]="'billingManual' | translator:'payment'"
                                             name="billingmanual"
                                             id="billingmanual"
                                        >
                                             Billing Manual
                                        </button>
                                   </li>
                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>